import { RSAA } from 'redux-api-middleware';
import sessionRedirectUtil from '../../utils/sessionRedirectUtils';
import { changeWindowHref } from '../../utils/redirectUtils';

export const DELETE_TOKEN = 'DELETE_TOKEN';
export const DELETE_TOKEN_SUCCESS = 'DELETE_TOKEN_SUCCESS';
export const DELETE_TOKEN_FAILED = 'DELETE_TOKEN_FAILED';
export const deleteToken = (token, bankId) => ({
  [RSAA]: {
    endpoint: `:api_paas_url/banks/${bankId}/auth/provider/oauth2/token/${token}`,
    method: 'DELETE',
    headers: {
      'x-bpi-version': '0.8.0'
    },
    types: [
      {
        type: DELETE_TOKEN
      },
      {
        type: DELETE_TOKEN_SUCCESS,
        meta: (_action, state) => changeWindowHref(sessionRedirectUtil.getRedirectUrl(state))
      },
      {
        type: DELETE_TOKEN_FAILED,
        meta: (_action, state) => changeWindowHref(sessionRedirectUtil.getRedirectUrl(state))
      }
    ]
  }
});
